<div class="reward-disabled-status">
  <div class="bg-{{ status.theme }} reward-status">
    <ng-container #statusContainer></ng-container>
  </div>
</div>
